import { render, staticRenderFns } from "./Question_F.vue?vue&type=template&id=0bf83db7&scoped=true&"
import script from "./Question_F.vue?vue&type=script&lang=js&"
export * from "./Question_F.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf83db7",
  null
  
)

export default component.exports